<mat-toolbar id="dialog-titlebar" mat-dialog-title color="primary">
  <span>{{ data.isEditMode ? 'Edit' : 'Create' }} Advanced Bundle</span>
</mat-toolbar>

<form [formGroup]="advancedBundleForm" class="normal-form" (submit)="onSubmit()">
  <div mat-dialog-content class="advanced-bundle-dialog-content">
    <div class="advanced-bundle-controls-group">
      <mat-form-field>
        <input matInput formControlName="name" placeholder="Bundle Name" required />
        <mat-error *ngIf="advancedBundleForm.controls.name.errors?.required">
          Bundle name is required.
        </mat-error>
        <mat-error *ngIf="advancedBundleForm.controls.name.errors?.minlength">
          Bundle name must be at least 3 characters.
        </mat-error>
        <mat-error *ngIf="advancedBundleForm.controls.name.errors?.maxlength">
          Bundle name cannot exceed 100 characters.
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Instrument Type</mat-label>
        <mat-select formControlName="deviceType" placeholder="Select instrument type" required>
          <mat-option *ngFor="let device of devices" [value]="device.id">
            {{ device.value }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="advancedBundleForm.controls.deviceType.errors?.required">
          Instrument type is required.
        </mat-error>
      </mat-form-field>

      <mat-form-field>
        <textarea
          matInput
          formControlName="description"
          placeholder="Bundle Description"
          rows="4"
        >
        </textarea>
        <mat-error *ngIf="advancedBundleForm.controls.description.errors?.minlength">
          Description must be at least 10 characters.
        </mat-error>
        <mat-error *ngIf="advancedBundleForm.controls.description.errors?.maxlength">
          Description cannot exceed 500 characters.
        </mat-error>
      </mat-form-field>
    </div>
  </div>

  <div mat-dialog-actions class="advanced-bundle-dialog-actions">
    <button
      mat-raised-button
      color="warn"
      type="button"
      (click)="onCancel()"
      [disabled]="isLoading"
    >
      Cancel
    </button>
    <button
      mat-raised-button
      color="primary"
      type="submit"
      [disabled]="advancedBundleForm.invalid || isLoading"
    >
      {{ data.isEditMode ? 'Update' : 'Create' }}
    </button>
  </div>
</form>
